import { Languages } from 'lucide-react'

import { useAdminI18n } from '@/lib/i18n/AdminI18nProvider'
import { useLocales } from '@/hooks/use-locales'
import { Select } from '@/components/ui/select'
import { cn } from '@/lib/utils'

export function AdminLanguageSwitcher({ className }: { className?: string }) {
  const { locale, setLocale, t } = useAdminI18n()
  const localesQ = useLocales()
  const locales = localesQ.data ?? []

  if (locales.length <= 1) return null

  return (
    <div className={cn('flex items-center gap-1', className)} title={t('common.language')}>
      <Languages className="hidden h-4 w-4 text-muted-foreground sm:block" aria-hidden />
      <Select
        className="h-9 w-[110px] border-0 bg-transparent px-1 shadow-none focus-visible:ring-0"
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        aria-label={t('common.language')}
      >
        {locales.map((l) => (
          <option key={l.code} value={l.code}>
            {(l.flag_emoji ? `${l.flag_emoji} ` : '') + (l.native_name || l.name || l.code)}
          </option>
        ))}
      </Select>
    </div>
  )
}
